/** Joyride portals the coachmark/beacon outside overlay hosts. */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export function isTourJoyrideInteractionTarget(
	target: EventTarget | null,
): boolean {
	return (
		target instanceof Element &&
		Boolean(
			target.closest(
				"#react-joyride-portal, [data-tour-coachmark], [data-joyride='beacon']",
			),
		)
	);
}
